import React, { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'
import GlobalVariable from '../../../../settings/global'
import { clearUserFiles } from '../../../../settings/config'

function decodeJwtPayload(token) {
  if (!token) return null
  const payload = token.split('.')[1]
  try {
    return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')))
  } catch (error) {
    console.error("Failed to decode JWT", error)
    return null
  }
}

function useSessionTimeout(token, refreshToken, sPopup, tokenShow) {
  const [refreshTokenCall, setRefreshTokenCall] = useState(false)
  const [isIdle, setIsIdle] = useState(false)
  const [showPopup, setShowPopup] = useState(sPopup)
  const [timeLeft, setTimeLeft] = useState(null)

  const idleTimeLimit = 120000 // 2 minutes
  const sessionLimit = 300000 // 5 minutes

  // Use react-idle-timer to manage idle state
  const { reset } = useIdleTimer({
    timeout: idleTimeLimit, // 2 minutes
    onIdle: () => {
      // console.log('User is idle')
      setIsIdle(true) // Set idle state when the user is idle
    },
    onActive: () => {
      // console.log('User is active')
      setTimeout(() => {
        if (isIdle && timeLeft > 120) {
          // console.log('Resetting idle state and timer')
          setIsIdle(false) // Reset idle state to false after a small delay to ensure user is truly active
          reset() // Reset the idle timer
        }
      }, 1000) // 1-second delay to ensure user activity is properly detected
    }
    // debounce: 1000 // Optional: delay before triggering events (in ms)
  })

  useEffect(() => {
    // Function to decode JWT
    const checkTokenExpiration = () => {
      const decodedToken = decodeJwtPayload(token)
      if (!decodedToken || !decodedToken.exp) return

      const currentTime = Date.now() / 1000
      const timeRemaining = decodedToken.exp - currentTime

      setTimeLeft(timeRemaining)

      // If token is expired, logout
      if (timeRemaining <= 0) {
        setShowPopup(false)
        window.location.href = GlobalVariable.AzureB2CLogoutUrl
        localStorage.clear()
        clearUserFiles()
      } else if (timeRemaining < sessionLimit / 1000) {
        if (timeRemaining < 120 && !isIdle && !refreshTokenCall) {
          refreshToken()
          setRefreshTokenCall(true)
        } else if (timeRemaining < 120 && isIdle) {
          setShowPopup(true) // Show popup if idle for 2 minutes and session is about to expire
        } else {
          setShowPopup(false)
        }
      } else {
        setShowPopup(false) // Hide popup if session time is more than 5 minutes
      }
    }
    // Start checking token expiration every second
    const intervalId = setInterval(checkTokenExpiration, 1000)

    // Cleanup function to clear the interval on unmount
    return () => {
      clearInterval(intervalId)
    }
  }, [token, isIdle, refreshTokenCall, tokenShow])

  useEffect(() => {
    setShowPopup(sPopup)
  }, [sPopup])

  return { showPopup, timeLeft }
}

export default useSessionTimeout